module.exports = __webpack_public_path__ + "img/Terms-Conditions.278efdb0.svg";